import React from 'react';
import Image from '../../../components/AppImage';

const HeroBanner = () => {
  return (
    <div className="w-full py-1 md:py-2 ">
      <div className="max-w-9xl mx-auto">
        <div className="relative w-full h-20 md:h-64 lg:h-60 ">
          

          <Image
            src="/assets/images/banner yeslamo red.svg"
            className="w-full h-full object-cover pl-2 lg:pl-18" />

        </div>
      </div>
    </div>
    );

};

export default HeroBanner;